/*接口地址配置文件*/
export const HOST_URL = URL_CONFIG.HOST_URL;// 域名地址
export const API_URL = URL_CONFIG.API_URL;// api 接口
export const SOCKET_URL = URL_CONFIG.SOCKET_URL;//socke服务地址
export const PRINT_SRC_URL = URL_CONFIG.PRINT_SRC_URL;// 打印插件下载地址
